import { IEndpointData } from 'SharedDir/declarations/shared';
import { SERVER_API } from 'SharedDir/constants/app/endpoints';

const statisticsPublic = `${SERVER_API}/public/statistics`;

export default {
  ISSUES: {
    method: 'GET',
    url: `${statisticsPublic}/issues`,
  } as IEndpointData,
  ISSUES_DEP: {
    method: 'GET',
    url: `${statisticsPublic}/issues/by-departments`,
  } as IEndpointData,
  USERS: {
    method: 'GET',
    url: `${statisticsPublic}/user-profiles`,
  } as IEndpointData,
  SERVICE_BY_DEPARTMENT: {
    method: 'GET',
    url: `${statisticsPublic}/services/by-departments`,
  } as IEndpointData,
};
